export const UnsetRid = 'ri.model.0.sentinel.unset';
